<div
  data-id="populations-overview"
  *transloco="
    let t;
    scope: 'featurePopulations';
    prefix: 'featurePopulations.populationOverview'
  "
  class="bd-populations-overview"
>
  <div data-id="populations-page-header" class="bd-populations-page-header">
    <bd-page-header
      [titleText]="{
        textKey: 'populationOverview.header',
        tScope: 'featurePopulations',
      }"
      [actions]="[newPopulationActionHeader]"
    >
    </bd-page-header>
  </div>
  <div class="bd-populations-search">
    <bd-searchbar
      data-id="search-populations-input"
      [placeholderText]="t('searchPlaceholder')"
      [searchSuggestions]="(searchSuggestions$ | async) ?? []"
      (submitTypeAheadSearch)="searchByName($event)"
      (clearSearch)="searchByName('')"
    ></bd-searchbar>
  </div>
  <p-table
    #populationsOverviewTable
    [scrollHeight]="'calc(11 * ' + SCROLL_HEIGHT + 'px)'"
    dataKey="id"
    data-id="populations-overview-table"
    styleClass="{{ populations.length === 0 ? 'bd-populations-empty' : '' }} {{
      populations.length < SCROLLABLE_ITEMS
        ? 'bd-populations-non-scrollable'
        : ''
    }} bd-populations-table
    "
    [scrollable]="populations.length >= SCROLLABLE_ITEMS"
    [virtualScroll]="populations.length >= SCROLLABLE_ITEMS"
    [virtualScrollItemSize]="SCROLL_HEIGHT"
    [lazy]="true"
    [loading]="isLoading"
    [showLoader]="false"
    [value]="populations"
    (onLazyLoad)="loadData($event)"
  >
    <ng-template #header>
      <tr>
        <th scope="col">
          {{ t('name') }}
        </th>
        <th scope="col">
          {{ t('definedBy') }}
        </th>
        <th scope="col">
          {{ t('createdBy') }}
        </th>
        <th scope="col">
          {{ t('createdDate') }}
        </th>
        <th scope="col"></th>
      </tr>
    </ng-template>
    <ng-template #body let-population>
      <tr
        [pSelectableRow]="population"
        [attr.data-id]="'populations-overview-table-row-' + population.id"
      >
        <td data-id="populations-overview-table-name">
          {{ population.name }}
        </td>
        <td
          data-id="populations-overview-table-defined-by"
          class="bd-secondary-text"
        >
          {{
            population.type === 'static'
              ? t('selectedObjects')
              : t('selectedFilters')
          }}
        </td>
        <td data-id="populations-overview-table-created-by">
          <div class="bd-cell-content">
            <p-avatar
              class="bd-size-small"
              data-id="user-avatar"
              [bdAvatar]="(population.createdBy | toAvatars)[0]"
            />
            <div class="overflow-hidden text-ellipsis">
              {{
                population.createdBy.firstName +
                  ' ' +
                  population.createdBy.lastName
              }}
            </div>
          </div>
        </td>
        <td data-id="populations-overview-table-created-date">
          {{ population.createdAt | date: 'd MMM y' }}
        </td>
        @if (actionMenuItems | translateMenuItems | async; as actionMenuItems) {
          <td>
            <p-button
              [attr.data-id]="'population-item-actions-' + population.id"
              [attr.aria-label]="t('actionsBtnInfo')"
              [text]="true"
              styleClass="bd-neutral bd-size-small {{
                actionMenu.visible ? 'bd-selected' : ''
              }}"
              icon="ui-ellipsis-vertical"
              (onClick)="
                onActionMenuClick(population); actionMenu.toggle($event)
              "
            >
            </p-button>
            <p-menu
              #actionMenu
              [attr.data-id]="'population-actions-menu-' + population.id"
              styleClass="bd-action-menu"
              [popup]="true"
              [model]="actionMenuItems"
              appendTo="body"
              (onHide)="actionMenu.visible = false"
            ></p-menu>
          </td>
        }
      </tr>
    </ng-template>
    <ng-template #loadingbody let-columns>
      @for (n of [].constructor(8); let index = $index; track index) {
        <tr [attr.data-id]="'loading-body-row-' + index">
          @for (n of [].constructor(4); let index = $index; track index) {
            <td class="border-b-0">
              @if (index !== 2) {
                <p-skeleton
                  [width]="index === 0 || index === 1 ? '160px' : '88px'"
                  height="20px"
                />
              } @else {
                <div class="flex gap-2 items-center">
                  <p-skeleton shape="circle" size="2rem" />
                  <p-skeleton width="160px" height="20px" />
                </div>
              }
            </td>
          }
        </tr>
      }
    </ng-template>
    <ng-template #emptymessage>
      <tr class="bd-populations-overview-empty-state-row">
        <td colspan="5">
          <bd-call-to-action
            data-id="no-populations-found"
            [darkBackground]="false"
            [icon]="'ui-cactus'"
            [title]="{
              textKey: 'populationOverview.noPopulations.title',
              tScope: 'featurePopulations',
            }"
            [subtitle]="{
              textKey: 'populationOverview.noPopulations.subtitle',
              tScope: 'featurePopulations',
            }"
            [actionButton]="newPopulationAction"
          >
          </bd-call-to-action>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
